import React from 'react';
import { Notice, Box } from '@applyboard/crystal-ui';
import { useApplicationDuplicates } from "../../../data";
import { getApplicationDuplicateInfo } from "../../../util/common";
var DuplicatesWarning = function DuplicatesWarning(_ref) {
  var applicationId = _ref.applicationId,
    applicantId = _ref.applicantId;
  var _useApplicationDuplic = useApplicationDuplicates(applicationId),
    applicationDuplicates = _useApplicationDuplic.applicationDuplicates;
  var _getApplicationDuplic = getApplicationDuplicateInfo({
      applicationDuplicates: applicationDuplicates,
      applicationId: applicationId,
      applicantId: applicantId
    }),
    someDuplicatesExistWithAnotherUser = _getApplicationDuplic.someDuplicatesExistWithAnotherUser,
    someDuplicatesExistWithSameUser = _getApplicationDuplic.someDuplicatesExistWithSameUser;
  var warningMessage = getWarningMessage({
    someDuplicatesExistWithAnotherUser: someDuplicatesExistWithAnotherUser,
    someDuplicatesExistWithSameUser: someDuplicatesExistWithSameUser
  });
  if (!warningMessage) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    pt: 1
  }, /*#__PURE__*/React.createElement(Notice, {
    intent: "negative"
  }, warningMessage));
};
var getWarningMessage = function getWarningMessage(_ref2) {
  var someDuplicatesExistWithAnotherUser = _ref2.someDuplicatesExistWithAnotherUser,
    someDuplicatesExistWithSameUser = _ref2.someDuplicatesExistWithSameUser;
  if (someDuplicatesExistWithSameUser && someDuplicatesExistWithAnotherUser) {
    return 'This Application may have duplicate under the current and different profile.';
  }
  if (someDuplicatesExistWithSameUser && !someDuplicatesExistWithAnotherUser) {
    return 'This Application may have duplicates under current profile.';
  }
  if (!someDuplicatesExistWithSameUser && someDuplicatesExistWithAnotherUser) {
    return 'This Application may have duplicates in a different profile.';
  }
  return null;
};
export default DuplicatesWarning;